import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// ... existing code ...
import HelloWorld from '@/views/HelloWorld.vue'
import FullPage from '@/views/FullPage.vue'
import IntoZhg from '@/views/IntoZhg.vue'
import dev from '@/views/dev.vue'
import core from '@/views/core.vue'
import coop from '@/views/coop.vue'
import join from '@/views/join.vue'
import news from '@/views/news.vue'
import message from '@/views/message.vue'
// ... existing code ...

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/fullpage',
      name: 'FullPage',
      component: FullPage
    },
    {
      path: '/intozhg',
      name: 'IntoZhg',
      component: IntoZhg
    },
    {
      path: '/dev',
      name: 'DevelopmentStrategy',
      component: dev
    },
    {
      path: '/core',
      name: 'core',
      component: core
    },
    {
      path: '/coop',
      name: 'coop',
      component: coop
    },
    {
      path: '/join',
      name: 'join',
      component: join
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/message',
      name: 'message',
      component: message
    }
    // ... 其他路由 ...
  ]
})
// ... existing code ...


// WEBPACK FOOTER //
// ./src/router/index.js